import { render, staticRenderFns } from "./TextareaBuilder.vue?vue&type=template&id=b8f5a2a0&scoped=true&"
import script from "./TextareaBuilder.vue?vue&type=script&lang=js&"
export * from "./TextareaBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TextareaBuilder.vue?vue&type=style&index=0&id=b8f5a2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5a2a0",
  null
  
)

export default component.exports